import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip, Button } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/presensiService"

import SimulationBloc from '../Blocs/SimulationBloc'
import apiResponse from '../../../../../services/apiResponse'

import ReactTimeAgo from 'react-time-ago'
import moment from "moment"

class TablePresensiDetailComponent extends Component {
    simulationBloc = new SimulationBloc()

    source

    constructor(props) {
        super(props)
        this.state = {
            loadingTable: false,
            cancelDate: null,
            rows: [],
        }
    }

    getIconPresensi = (inp, val) => {
        if (inp != null) {
            if (val == 'Finger Print') {
                return (
                    <>
                        <br /> <i className="bx bx-fingerprint"></i>
                    </>
                )
            }

            if (val == 'Mobile') {
                return (
                    <>
                        <br /> <i className="bx bx-mobile-alt"></i>
                    </>
                )
            }
        }

        return '';
    }

    dateParse = (input) => {
        let res = "-";
        if (input != "" && input != null) {
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    loadData = async () => {
        this.setState({ loading: true })
        var filter = this.props.filter
        this.simulationBloc.fetchSimulation({ uuid: this.props.uuid, ...filter });
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.cancelDate()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }


    componentDidMount() {
        this.setTokenAPI()

        this.simulationBloc.simulationChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false,
                        loading: false,
                        rows: []
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true,
                        loading: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        rows: response.result,
                        loading: false
                    })
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.simulationBloc.simulationChannel.unsubscribe()
    }

        formatTime = (timeStr) => {
        if (!timeStr || timeStr === '00:00:00' || timeStr === '-') return '';
        return timeStr.substring(0, 5);
    }

    render() {
        const hasAksi = false;
        const col1Left = 0;
        const col1Width = 110;
        const col2Left = col1Left + col1Width;
        const col2Width = 100;
        const col3Left = col2Left + col2Width;
        const col3Width = 100;

        const aksiWidth = 100;
        const aksiRight = 0;
        const polaKerjaWidth = 100;
        const keteranganWidth = 200;
        const polaKerjaRight = hasAksi ? aksiWidth : 0;
        const keteranganRight = polaKerjaRight + polaKerjaWidth;

        let sumTunkinNotPresent = 0;
        let sumHonorNotPresent = 0;
        let sumTunkinSFinger = 0;
        let sumHonorSFinger = 0;
        let sumTunkinLate = 0;
        let sumHonorLate = 0;
        let sumTunkinEarly = 0;
        let sumHonorEarly = 0;
        let sumTunsusNotPresent = 0;
        let sumTunsusSFinger = 0;
        let sumTunsusLate = 0;
        let sumTunsusEarly = 0;

        Object.values(this.state.rows || {}).forEach(item => {
            sumTunkinNotPresent += parseFloat(item.presensi_result_precent_tunkin_not_present) || 0;
            sumHonorNotPresent += parseFloat(item.presensi_result_precent_ptsp_not_present) || 0;
            sumTunkinSFinger += parseFloat(item.presensi_result_precent_tunkin_single_finger) || 0;
            sumHonorSFinger += parseFloat(item.presensi_result_precent_ptsp_single_finger) || 0;
            sumTunkinLate += parseFloat(item.presensi_result_precent_tunkin_late) || 0;
            sumHonorLate += parseFloat(item.presensi_result_precent_ptsp_late) || 0;
            sumTunkinEarly += parseFloat(item.presensi_result_precent_tunkin_early) || 0;
            sumHonorEarly += parseFloat(item.presensi_result_precent_ptsp_early) || 0;
            sumTunsusNotPresent += parseFloat(item.presensi_result_tunsus_precent_not_present) || 0;
            sumTunsusSFinger += parseFloat(item.presensi_result_tunsus_precent_single_finger) || 0;
            sumTunsusLate += parseFloat(item.presensi_result_tunsus_precent_late) || 0;
            sumTunsusEarly += parseFloat(item.presensi_result_tunsus_precent_early) || 0;
        });

        return (
            <>
                <div className="table-responsive" style={{ minWidth: '100%', maxHeight: "75vh", overflowX: "auto", overflowY: "auto" }}>
                    <Table
                        className="table table-striped table-bordered table-hover"
                        style={{ minWidth: "1400px", borderCollapse: "separate", borderSpacing: 0 }}
                    >
                        <thead style={{ position: 'sticky', top: 0, zIndex: 3, backgroundColor: '#f8f9fa' }}>
                            <tr>
                                <th rowSpan="3" className="text-center align-middle" style={{ position: 'sticky', left: col1Left, zIndex: 4, backgroundColor: '#f8f9fa', minWidth: `${col1Width}px`, boxShadow: 'inset -1px 0 0 #dee2e6, inset 0 -1px 0 #dee2e6' }}>Hari<br />Tanggal</th>
                                <th colSpan="3" className="text-center align-middle" style={{ position: 'sticky', left: col2Left, zIndex: 4, backgroundColor: '#f8f9fa', boxShadow: 'inset -1px 0 0 #dee2e6, inset 0 -1px 0 #dee2e6' }}>PRESENSI</th>

                                <th colSpan="7" className="text-center align-middle" style={{ backgroundColor: '#f4f9f5' }} width="*">TUNKIN</th>
                                <th colSpan="7" className="text-center align-middle" style={{ backgroundColor: '#f1f5fe' }} width="*">TUNSUS</th>
                                <th colSpan="7" className="text-center align-middle" style={{ backgroundColor: '#fffdf6' }} width="*">HONOR</th>

                                <th rowSpan="3" className="text-center align-middle" style={{ position: 'sticky', right: keteranganRight, zIndex: 4, backgroundColor: '#f8f9fa', minWidth: `${keteranganWidth}px`, boxShadow: 'inset 1px 0 0 #dee2e6, inset 0 -1px 0 #dee2e6' }}>Keterangan</th>
                                <th rowSpan="3" className="text-center align-middle" style={{ position: 'sticky', right: polaKerjaRight, zIndex: 4, backgroundColor: '#f8f9fa', minWidth: `${polaKerjaWidth}px`, boxShadow: 'inset 1px 0 0 #dee2e6, inset 0 -1px 0 #dee2e6' }}>Pola Kerja</th>
                                {hasAksi ? <th rowSpan="3" className="text-center align-middle" style={{ position: 'sticky', right: aksiRight, zIndex: 4, backgroundColor: '#f8f9fa', minWidth: `${aksiWidth}px`, boxShadow: 'inset 1px 0 0 #dee2e6, inset 0 -1px 0 #dee2e6' }}>Aksi</th> : null}
                            </tr>
                            <tr>
                                <th rowSpan="2" className="text-center align-middle" style={{ position: 'sticky', left: col2Left, zIndex: 4, backgroundColor: '#f8f9fa', minWidth: `${col2Width}px`, boxShadow: 'inset -1px 0 0 #dee2e6, inset 0 -1px 0 #dee2e6' }}>Masuk</th>
                                <th rowSpan="2" className="text-center align-middle" style={{ position: 'sticky', left: col3Left, zIndex: 4, backgroundColor: '#f8f9fa', minWidth: `${col3Width}px`, boxShadow: 'inset -1px 0 0 #dee2e6, inset 0 -1px 0 #dee2e6' }}>Pulang</th>
                                <th rowSpan="2" className="text-center align-middle" style={{ position: 'sticky', left: col3Left + col3Width, zIndex: 4, backgroundColor: '#f8f9fa', minWidth: '80px', boxShadow: 'inset -1px 0 0 #dee2e6, inset 0 -1px 0 #dee2e6' }}>Hadir</th>

                                {/* TUNKIN */}
                                <th rowSpan="2" className="text-center align-middle" style={{ backgroundColor: '#f4f9f5' }} width="*">Kehadiran<br />(%)</th>
                                <th colSpan="2" className="text-center align-middle" style={{ backgroundColor: '#f4f9f5' }} width="*">S.Finger</th>
                                <th colSpan="2" className="text-center align-middle" style={{ backgroundColor: '#f4f9f5' }} width="*">Terlambat</th>
                                <th colSpan="2" className="text-center align-middle" style={{ backgroundColor: '#f4f9f5' }} width="*">Pulang Cepat</th>

                                {/* TUNSUS */}
                                <th rowSpan="2" className="text-center align-middle" style={{ backgroundColor: '#f1f5fe' }} width="*">Kehadiran<br />(%)</th>
                                <th colSpan="2" className="text-center align-middle" style={{ backgroundColor: '#f1f5fe' }} width="*">S.Finger</th>
                                <th colSpan="2" className="text-center align-middle" style={{ backgroundColor: '#f1f5fe' }} width="*">Terlambat</th>
                                <th colSpan="2" className="text-center align-middle" style={{ backgroundColor: '#f1f5fe' }} width="*">Pulang Cepat</th>

                                {/* HONOR */}
                                <th rowSpan="2" className="text-center align-middle" style={{ backgroundColor: '#fffdf6' }} width="*">Kehadiran<br />(%)</th>
                                <th colSpan="2" className="text-center align-middle" style={{ backgroundColor: '#fffdf6' }} width="*">S.Finger</th>
                                <th colSpan="2" className="text-center align-middle" style={{ backgroundColor: '#fffdf6' }} width="*">Terlambat</th>
                                <th colSpan="2" className="text-center align-middle" style={{ backgroundColor: '#fffdf6' }} width="*">Pulang Cepat</th>
                            </tr>
                            <tr>
                                {/* TUNKIN */}
                                <th className="text-center align-middle" style={{ backgroundColor: '#f4f9f5' }} width="*">Waktu</th>
                                <th className="text-center align-middle" style={{ backgroundColor: '#f4f9f5' }} width="*">%</th>
                                <th className="text-center align-middle" style={{ backgroundColor: '#f4f9f5' }} width="*">Waktu</th>
                                <th className="text-center align-middle" style={{ backgroundColor: '#f4f9f5' }} width="*">%</th>
                                <th className="text-center align-middle" style={{ backgroundColor: '#f4f9f5' }} width="*">Waktu</th>
                                <th className="text-center align-middle" style={{ backgroundColor: '#f4f9f5' }} width="*">%</th>

                                {/* TUNSUS */}
                                <th className="text-center align-middle" style={{ backgroundColor: '#f1f5fe' }} width="*">Waktu</th>
                                <th className="text-center align-middle" style={{ backgroundColor: '#f1f5fe' }} width="*">%</th>
                                <th className="text-center align-middle" style={{ backgroundColor: '#f1f5fe' }} width="*">Waktu</th>
                                <th className="text-center align-middle" style={{ backgroundColor: '#f1f5fe' }} width="*">%</th>
                                <th className="text-center align-middle" style={{ backgroundColor: '#f1f5fe' }} width="*">Waktu</th>
                                <th className="text-center align-middle" style={{ backgroundColor: '#f1f5fe' }} width="*">%</th>

                                {/* HONOR */}
                                <th className="text-center align-middle" style={{ backgroundColor: '#fffdf6' }} width="*">Waktu</th>
                                <th className="text-center align-middle" style={{ backgroundColor: '#fffdf6' }} width="*">%</th>
                                <th className="text-center align-middle" style={{ backgroundColor: '#fffdf6' }} width="*">Waktu</th>
                                <th className="text-center align-middle" style={{ backgroundColor: '#fffdf6' }} width="*">%</th>
                                <th className="text-center align-middle" style={{ backgroundColor: '#fffdf6' }} width="*">Waktu</th>
                                <th className="text-center align-middle" style={{ backgroundColor: '#fffdf6' }} width="*">%</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                Object.entries(this.state.rows || {}).map((item, key) => {
                                    const thisId = item[0];
                                    let cancelAvailable = false
                                    if (item[1].result_checkin !== null && item[1].result_checkout !== null) {
                                        cancelAvailable = true
                                    }
                                    
                                    let color = "";
                                    const type = [1, 10];
                                    if (item[1].presensi_result_type == 1 || item[1].presensi_result_type == 10) color = "text-danger";
                                    // if (item[1].presensi_result_type == 10) color = "text-danger";
                                    if (item[1].presensi_result_type > 1 && item[1].presensi_result_type != 10) color = "text-primary";

                                    return (
                                        <tr key={key}>
                                            <td className={`text-center ${color}`} style={{ position: 'sticky', left: col1Left, zIndex: 1, backgroundColor: '#ffffff', minWidth: `${col1Width}px`, boxShadow: 'inset -1px 0 0 #dee2e6' }}>
                                                {this.dateParse(item[1].presensi_result_date)}<br />
                                                <small>{item[1].presensi_result_day_name}</small>
                                            </td>

                                            {
                                                (item[1].presensi_result_type == 1 || item[1].presensi_result_type == 10) ?
                                                    <>
                                                        <td className="text-center" style={{ position: 'sticky', left: col2Left, zIndex: 1, backgroundColor: '#ffffff', minWidth: `${col2Width}px`, boxShadow: 'inset -1px 0 0 #dee2e6' }}>{this.formatTime(item[1].presensi_result_checkin)} {this.getIconPresensi(item[1].presensi_result_checkin, item[1].presensi_result_checkin_from)}</td>
                                                        <td className="text-center" style={{ position: 'sticky', left: col3Left, zIndex: 1, backgroundColor: '#ffffff', minWidth: `${col3Width}px`, boxShadow: 'inset -1px 0 0 #dee2e6' }}>{this.formatTime(item[1].presensi_result_checkout)} {this.getIconPresensi(item[1].presensi_result_checkout, item[1].presensi_result_checkout_from)}</td>
                                                        <td className="text-center" style={{ position: 'sticky', left: col3Left + col3Width, zIndex: 1, backgroundColor: '#ffffff', minWidth: '80px', boxShadow: 'inset -1px 0 0 #dee2e6' }}>
                                                            {((parseFloat(item[1].presensi_result_precent_tunkin_not_present) > 0 || parseFloat(item[1].presensi_result_precent_ptsp_not_present) > 0 || parseFloat(item[1].presensi_result_tunsus_precent_not_present) > 0) ? 'Tidak' : (item[1].presensi_result_is_present === 1 ? 'Ya' : ''))}
                                                        </td>
                                                        <td className="text-center align-middle font-weight-bold" style={{ backgroundColor: '#f8d7da', color: '#721c24' }} colSpan="21">{item[1].presensi_result_type_name}</td>
                                                        <td className="text-left" style={{ position: 'sticky', right: keteranganRight, zIndex: 1, backgroundColor: '#ffffff', minWidth: `${keteranganWidth}px`, boxShadow: 'inset 1px 0 0 #dee2e6' }}></td>
                                                        <td className="text-left" style={{ position: 'sticky', right: polaKerjaRight, zIndex: 1, backgroundColor: '#ffffff', minWidth: `${polaKerjaWidth}px`, boxShadow: 'inset 1px 0 0 #dee2e6' }}>{item[1].presensi_result_working_pattern}</td>
                                                        {hasAksi && item[1].presensi_type == 1 && item[1].presensi_result_date <= moment().format('YYYY-MM-DD') && item[1].presensi_result_date >= moment().startOf('month').format('YYYY-MM-DD') ?
                                                            <td className="text-center" style={{ position: 'sticky', right: 0, zIndex: 1, backgroundColor: '#ffffff', minWidth: `${aksiWidth}px`, boxShadow: 'inset 1px 0 0 #dee2e6' }}>
                                                                
                                                            </td>
                                                            : ""
                                                        }
                                                    </>
                                                    :
                                                    <>
                                                        <td className="text-center" style={{ position: 'sticky', left: col2Left, zIndex: 1, backgroundColor: '#ffffff', minWidth: `${col2Width}px`, boxShadow: 'inset -1px 0 0 #dee2e6' }}>{this.formatTime(item[1].presensi_result_checkin)} {this.getIconPresensi(item[1].presensi_result_checkin, item[1].presensi_result_checkin_from)}</td>
                                                        <td className="text-center" style={{ position: 'sticky', left: col3Left, zIndex: 1, backgroundColor: '#ffffff', minWidth: `${col3Width}px`, boxShadow: 'inset -1px 0 0 #dee2e6' }}>{this.formatTime(item[1].presensi_result_checkout)} {this.getIconPresensi(item[1].presensi_result_checkout, item[1].presensi_result_checkout_from)}</td>
                                                        {/* PRESENSI HADIR */}
                                                        <td className="text-center" style={{ position: 'sticky', left: col3Left + col3Width, zIndex: 1, backgroundColor: '#ffffff', minWidth: '80px', boxShadow: 'inset -1px 0 0 #dee2e6' }}>
                                                            {((parseFloat(item[1].presensi_result_precent_tunkin_not_present) > 0 || parseFloat(item[1].presensi_result_precent_ptsp_not_present) > 0 || parseFloat(item[1].presensi_result_tunsus_precent_not_present) > 0) ? 'Tidak' : (item[1].presensi_result_is_present === 1 ? 'Ya' : ''))}
                                                        </td>

                                                        {/* TUNKIN */}
                                                        <td className="text-center" style={{ backgroundColor: '#f4f9f5' }}>{parseFloat(item[1].presensi_result_precent_tunkin_not_present) > 0 ? item[1].presensi_result_precent_tunkin_not_present : ""}</td>

                                                        <td className="text-center" style={{ backgroundColor: '#f4f9f5' }}>{item[1].presensi_result_is_single_finger === 0 ? '' : this.formatTime(item[1].presensi_result_single_finger)}</td>
                                                        <td className="text-center" style={{ backgroundColor: '#f4f9f5' }}>{item[1].presensi_result_precent_tunkin_single_finger}</td>

                                                        <td className="text-center" style={{ backgroundColor: '#f4f9f5' }}>{this.formatTime(item[1].presensi_result_late)}</td>
                                                        <td className="text-center" style={{ backgroundColor: '#f4f9f5' }}>{item[1].presensi_result_precent_tunkin_late}</td>

                                                        <td className="text-center" style={{ backgroundColor: '#f4f9f5' }}>{this.formatTime(item[1].presensi_result_early)}</td>
                                                        <td className="text-center" style={{ backgroundColor: '#f4f9f5' }}>{item[1].presensi_result_precent_tunkin_early}</td>

                                                        {/* TUNSUS */}
                                                        <td className="text-center" style={{ backgroundColor: '#f1f5fe' }}>{parseFloat(item[1].presensi_result_tunsus_precent_not_present) > 0 ? item[1].presensi_result_tunsus_precent_not_present : ""}</td>

                                                        <td className="text-center" style={{ backgroundColor: '#f1f5fe' }}>{item[1].presensi_result_tunsus_is_single_finger === 0 ? '' : this.formatTime(item[1].presensi_result_tunsus_single_finger)}</td>
                                                        <td className="text-center" style={{ backgroundColor: '#f1f5fe' }}>{item[1].presensi_result_tunsus_precent_single_finger || ''}</td>

                                                        <td className="text-center" style={{ backgroundColor: '#f1f5fe' }}>{this.formatTime(item[1].presensi_result_tunsus_late)}</td>
                                                        <td className="text-center" style={{ backgroundColor: '#f1f5fe' }}>{item[1].presensi_result_tunsus_precent_late || ''}</td>

                                                        <td className="text-center" style={{ backgroundColor: '#f1f5fe' }}>{this.formatTime(item[1].presensi_result_tunsus_early)}</td>
                                                        <td className="text-center" style={{ backgroundColor: '#f1f5fe' }}>{item[1].presensi_result_tunsus_precent_early || ''}</td>

                                                        {/* HONOR */}
                                                        <td className="text-center" style={{ backgroundColor: '#fffdf6' }}>{parseFloat(item[1].presensi_result_precent_ptsp_not_present) > 0 ? item[1].presensi_result_precent_ptsp_not_present : ""}</td>

                                                        <td className="text-center" style={{ backgroundColor: '#fffdf6' }}>{item[1].presensi_result_is_single_finger === 0 ? '' : this.formatTime(item[1].presensi_result_single_finger)}</td>
                                                        <td className="text-center" style={{ backgroundColor: '#fffdf6' }}>{item[1].presensi_result_precent_ptsp_single_finger}</td>

                                                        <td className="text-center" style={{ backgroundColor: '#fffdf6' }}>{this.formatTime(item[1].presensi_result_late)}</td>
                                                        <td className="text-center" style={{ backgroundColor: '#fffdf6' }}>{item[1].presensi_result_precent_ptsp_late}</td>

                                                        <td className="text-center" style={{ backgroundColor: '#fffdf6' }}>{this.formatTime(item[1].presensi_result_early)}</td>
                                                        <td className="text-center" style={{ backgroundColor: '#fffdf6' }}>{item[1].presensi_result_precent_ptsp_early}</td>

                                                        <td className="text-left" style={{ position: 'sticky', right: keteranganRight, zIndex: 1, backgroundColor: '#ffffff', minWidth: `${keteranganWidth}px`, boxShadow: 'inset 1px 0 0 #dee2e6' }}>{item[1].presensi_type == -1 ? item[1].presensi_type_name : item[1].presensi_result_type_name}</td>
                                                        <td className="text-left" style={{ position: 'sticky', right: polaKerjaRight, zIndex: 1, backgroundColor: '#ffffff', minWidth: `${polaKerjaWidth}px`, boxShadow: 'inset 1px 0 0 #dee2e6' }}>{item[1].presensi_result_working_pattern}</td>
                                                    </>
                                            }
                                        </tr>
                                    )
                                })
                            }
                            <tr style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}>
                                <td colSpan="4" className="text-center" style={{ position: 'sticky', bottom: 0, left: col1Left, zIndex: 4, backgroundColor: '#f8f9fa', boxShadow: 'inset -1px 0 0 #dee2e6, inset 0 1px 0 #dee2e6' }}>JUMLAH %</td>

                                {/* TUNKIN Sums */}
                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#e6f4ea', boxShadow: 'inset 0 1px 0 #dee2e6' }}>{sumTunkinNotPresent > 0 ? sumTunkinNotPresent.toFixed(2) : ''}</td>

                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#e6f4ea', boxShadow: 'inset 0 1px 0 #dee2e6' }}></td>
                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#e6f4ea', boxShadow: 'inset 0 1px 0 #dee2e6' }}>{sumTunkinSFinger > 0 ? sumTunkinSFinger.toFixed(2) : ''}</td>

                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#e6f4ea', boxShadow: 'inset 0 1px 0 #dee2e6' }}></td>
                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#e6f4ea', boxShadow: 'inset 0 1px 0 #dee2e6' }}>{sumTunkinLate > 0 ? sumTunkinLate.toFixed(2) : ''}</td>

                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#e6f4ea', boxShadow: 'inset 0 1px 0 #dee2e6' }}></td>
                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#e6f4ea', boxShadow: 'inset 0 1px 0 #dee2e6' }}>{sumTunkinEarly > 0 ? sumTunkinEarly.toFixed(2) : ''}</td>

                                {/* TUNSUS Sums */}
                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#e8f0fe', boxShadow: 'inset 0 1px 0 #dee2e6' }}>{sumTunsusNotPresent > 0 ? sumTunsusNotPresent.toFixed(2) : ''}</td>

                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#e8f0fe', boxShadow: 'inset 0 1px 0 #dee2e6' }}></td>
                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#e8f0fe', boxShadow: 'inset 0 1px 0 #dee2e6' }}>{sumTunsusSFinger > 0 ? sumTunsusSFinger.toFixed(2) : ''}</td>

                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#e8f0fe', boxShadow: 'inset 0 1px 0 #dee2e6' }}></td>
                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#e8f0fe', boxShadow: 'inset 0 1px 0 #dee2e6' }}>{sumTunsusLate > 0 ? sumTunsusLate.toFixed(2) : ''}</td>

                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#e8f0fe', boxShadow: 'inset 0 1px 0 #dee2e6' }}></td>
                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#e8f0fe', boxShadow: 'inset 0 1px 0 #dee2e6' }}>{sumTunsusEarly > 0 ? sumTunsusEarly.toFixed(2) : ''}</td>

                                {/* HONOR Sums */}
                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#fffdf6', boxShadow: 'inset 0 1px 0 #dee2e6' }}>{sumHonorNotPresent > 0 ? sumHonorNotPresent.toFixed(2) : ''}</td>

                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#fffdf6', boxShadow: 'inset 0 1px 0 #dee2e6' }}></td>
                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#fffdf6', boxShadow: 'inset 0 1px 0 #dee2e6' }}>{sumHonorSFinger > 0 ? sumHonorSFinger.toFixed(2) : ''}</td>

                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#fffdf6', boxShadow: 'inset 0 1px 0 #dee2e6' }}></td>
                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#fffdf6', boxShadow: 'inset 0 1px 0 #dee2e6' }}>{sumHonorLate > 0 ? sumHonorLate.toFixed(2) : ''}</td>

                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#fffdf6', boxShadow: 'inset 0 1px 0 #dee2e6' }}></td>
                                <td className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 3, backgroundColor: '#fffdf6', boxShadow: 'inset 0 1px 0 #dee2e6' }}>{sumHonorEarly > 0 ? sumHonorEarly.toFixed(2) : ''}</td>

                                <td className="text-center" style={{ position: 'sticky', bottom: 0, right: keteranganRight, zIndex: 4, backgroundColor: '#f8f9fa', boxShadow: 'inset 1px 0 0 #dee2e6, inset 0 1px 0 #dee2e6' }}></td>
                                <td className="text-center" style={{ position: 'sticky', bottom: 0, right: polaKerjaRight, zIndex: 4, backgroundColor: '#f8f9fa', boxShadow: 'inset 1px 0 0 #dee2e6, inset 0 1px 0 #dee2e6' }}></td>
                                {hasAksi ? <td className="text-center" style={{ position: 'sticky', bottom: 0, right: 0, zIndex: 4, backgroundColor: '#f8f9fa', boxShadow: 'inset 1px 0 0 #dee2e6, inset 0 1px 0 #dee2e6' }}></td> : null}
                            </tr>
                        </tbody>
                    </Table>

                    <ConfirmAlert
                        confirmTitle="Konfirmasi!"
                        confirmInfo="Apakah anda yakin akan membatalkan data presensi ini?"

                        loadingTitle="Mengambil data"
                        loadingInfo="Tunggu beberapa saat"

                        successTitle="Berhasil!"
                        successInfo="Data berhasil dihapus"

                        failedTitle="Gagal!"
                        failedInfo="Data gagal dihapus"

                        showConfirm={this.state.confirm}
                        showLoading={this.state.loading}
                        showSuccess={this.state.success}
                        showFailed={this.state.failed}

                        response={this.confirmResponse}
                    />
                </div>
            </>
        )

    }
}

export default TablePresensiDetailComponent